import { TagItemProps } from '.'
import { isString } from '../../../utils'
import {
  IconImage,
  TabSubLabel,
  TagItemWrapper,
  TagLabel,
  TagMessage
} from './Tags.styles'
import Icon from '../Icon'

const TagItem = ({
  className = '',
  label,
  subLabel,
  icon,
  iconImage,
  longText,
  message,
  styles,
  ...props
}: TagItemProps) => {
  const iconProps = isString(icon) ? { name: icon } : icon
  const iconComp = icon ? <Icon {...iconProps} /> : undefined
  const labelProps = isString(label) ? { value: label } : label
  const labelSize = labelProps?.value?.length || 0
  const longTextValue = longText && labelSize >= longText ? labelSize : 0
  const subLabelProps = isString(subLabel) ? { value: subLabel } : subLabel
  const messageProps = isString(message) ? { value: message } : message
  const labelComp = (
    <>
      <TagLabel className="TagLabel" {...labelProps} />
      {!!subLabel && <TabSubLabel {...subLabelProps} />}
    </>
  )
  const iconImageComp = iconImage ? (
    <IconImage src={iconImage} alt="icon" />
  ) : undefined

  return (
    <>
      <TagItemWrapper
        key={labelProps?.value}
        className={`TagItem ${className}`}
        label={labelComp}
        icon={iconImageComp || iconComp}
        longText={longTextValue}
        sx={styles}
        {...props}
      />
      {!!message && <TagMessage {...messageProps} />}
    </>
  )
}

export default TagItem
